/**
 * 路由配置
 * 包含登录页、布局页和各功能模块
 */

import type { RouteObject } from 'react-router-dom';
import Login from '../pages/Login';
import BasicLayout from '../layouts/BasicLayout';
import Dashboard from '../pages/Dashboard';
import Users from '../pages/Users';
import System from '../pages/System';
import Applications from '../pages/Applications';
import RoleManager from '../pages/RoleManager';
import MenuManager from '../pages/MenuManager';
import OperationLog from '../pages/OperationLog';
import DeptManager from '../pages/DeptManager';
import LoginLog from '../pages/LoginLog';
import AiServiceConfig from '../pages/AiServiceConfig';
import PersonalityTemplate from '../pages/PersonalityTemplate';
import CharacterGenerator from '../pages/CharacterGenerator';
import CharacterList from '../pages/CharacterList';
import CharacterPreview from '../pages/CharacterPreview';
import BudgetConfig from '../pages/BudgetConfig';

// 路由守卫组件
const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    // 重定向到登录页
    window.location.href = '/login';
    return null;
  }

  return <>{children}</>;
};

// 登录页路由（无需认证）
const LoginRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('token');

  if (token) {
    // 已登录，跳转到首页
    window.location.href = '/dashboard';
    return null;
  }

  return <>{children}</>;
};

export const routes: RouteObject[] = [
  // 登录页
  {
    path: '/login',
    element: (
      <LoginRoute>
        <Login />
      </LoginRoute>
    ),
  },

  // 主布局（需要认证）
  {
    path: '/',
    element: (
      <PrivateRoute>
        <BasicLayout />
      </PrivateRoute>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'system',
        element: <System />,
      },
      {
        path: 'user',
        element: <Users />,
      },
      {
        path: 'users',
        element: <Users />,
      },
      {
        path: 'role',
        element: <RoleManager />,
      },
      {
        path: 'roles',
        element: <RoleManager />,
      },
      {
        path: 'menu',
        element: <MenuManager />,
      },
      {
        path: 'menus',
        element: <MenuManager />,
      },
      {
        path: 'dept',
        element: <DeptManager />,
      },
      {
        path: 'log',
        element: <OperationLog />,
      },
      {
        path: 'operlog',
        element: <OperationLog />,
      },
      {
        path: 'loginlog',
        element: <LoginLog />,
      },
      {
        path: 'application',
        element: <Applications />,
      },
      {
        path: 'applications',
        element: <Applications />,
      },
      {
        path: 'ai-service',
        element: <AiServiceConfig />,
      },
      {
        path: 'personality',
        element: <PersonalityTemplate />,
      },
      // 电子人管理路由
      {
        path: 'character/generate',
        element: <CharacterGenerator />,
      },
      {
        path: 'character/list',
        element: <CharacterList />,
      },
      {
        path: 'character/preview/:characterId',
        element: <CharacterPreview />,
      },
      {
        path: 'budget',
        element: <BudgetConfig />,
      },
    ],
  },

  // 404 页面
  {
    path: '*',
    element: <div>404 - Page Not Found</div>,
  },
];
